export default __webpack_public_path__ + "static/media/freeIcon.8b67ca60.png";